
import { Route, Routes } from 'react-router-dom';
import './App.css';
import About from './Components/About/About';
import RequireAuth from './Components/About/RequireAuth';
import Blog from './Components/Blogs/Blog';
import Checkout from './Components/Checkout/Checkout';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import Login from './Components/Login/Login';
import Notfound from './Components/NotFound/Notfound';
import Register from './Components/Register/Register';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}>Home</Route>
        <Route path='/login' element={<Login></Login>}>Login</Route>
        <Route path='/about' element={<About></About>}>Login</Route>
        <Route path='/blogs' element={<Blog></Blog>}>Login</Route>
        <Route path='/checkout' element={
          <RequireAuth><Checkout></Checkout></RequireAuth>
        }>checkout</Route>
        <Route path='/register' element={<Register></Register>}>Register</Route>
        <Route path='*' element={<Notfound></Notfound>}></Route>
      </Routes>

    </div>
  );
}

export default App;
